import { Api } from "../api";
import { FileWorkspace, FileReplace } from "../../context/UploadProvider/typesUpload";
import { CancelTokenSource } from 'axios';
import { FileCreatedWebVO } from "../../model/ItemModel"
import { PaywallInformation } from "../../model/PaywallModel";

const CHUNK_SIZE = 1 * 1024 * 1024; // 1MB de tamanho por chunk

export function UploadItem(
    fileWorkspace: FileWorkspace,
    signal?: AbortSignal
) {
    var formData = new FormData();
    formData.append("fileName", `${fileWorkspace.file.name}`);

    let urlUpload: string = "";

    if (fileWorkspace.folder == undefined) {
        urlUpload = 'Item/file/' + fileWorkspace.woskpace;
    }
    else {
        urlUpload = 'Item/file/' + fileWorkspace.woskpace + "/" + fileWorkspace.folder;
    }

    return Api.post<FileCreatedWebVO>(urlUpload,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            signal: signal
        });
}

export function VerifyItem(
    fileWorkspace: FileWorkspace,
    idWorkspace: string,
    nameOrg: string,
    signal?: AbortSignal
) {
    var formData = new FormData();
    formData.append("file", fileWorkspace?.file);

    return Api.post<PaywallInformation>(`paywall/VerifyItems/${nameOrg}/${idWorkspace}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            signal: signal
        });
}

export function UploadExistingFile(
    fileReplace: FileReplace,
    signal?: AbortSignal

) {
    var formData = new FormData();
    formData.append("file", fileReplace.file);
    formData.append("fileName", fileReplace.file.name);

    return Api.post<FileCreatedWebVO>(`Item/file/upload/${fileReplace.idItem}`,
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        signal: signal

    });
}


export function readFileInChunks(file: File): Blob[] {
    const chunks: Blob[] = [];
    let offset = 0;

    while (offset < file.size) {
        const chunk = file.slice(offset, offset + CHUNK_SIZE);
        chunks.push(chunk);
        offset += CHUNK_SIZE;
    }

    return chunks;
}

export function UploadFileChunk(
    chunks: Blob[],
    currentChunk: number,
    file: File,
    signal?: AbortSignal
) {
    const chunk = chunks[currentChunk];

    const formData = new FormData();
    formData.append('file', chunk, file.name);
    formData.append('chunkIndex', currentChunk.toString());
    formData.append('totalChunks', chunks.length.toString());

    return Api.post('Item/file/upload-chunk', formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            signal: signal
        })

}